import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Schedule } from 'src/app/shared/models/schedule.model';
import { environment } from 'src/environments/environment';
import { map, catchError } from 'rxjs/operators';
import { throwError, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TrainingSessionsService {
  private _schedulesArray: Schedule[] = [];
  private _scheduleDescriptionsArray: { [name: string]: any } = [];

  public onScheduleEdit: Subject<number> = new Subject();
  public onScheduleDelete: Subject<number> = new Subject();
  public onSchedulesArrayChange: Subject<void> = new Subject();

  constructor(private _http: HttpClient) { }

  public get schedules(): Schedule[] {
    return Object.assign([], this._schedulesArray.slice());
  }

  public get scheduleDescriptions(): { [name: string]: any } {
    return this._scheduleDescriptionsArray;
  }

  /**
   * getSchedulesOfOrganiaztion
   */
  public getSchedulesOfOrganiaztion(orgId: number) {
    let paramas = new HttpParams();
    paramas = paramas.append('id', orgId.toString());
    return this._http.get<{
      schedule: Schedule[],
      scheduleDescription: { [name: string]: any }
    }>(environment.serverUrl + 'schedules/getByOrganization', {
      params: paramas,
    }).pipe(
      map(responseData => {
        this._schedulesArray = [];
        this._schedulesArray.push(...responseData.schedule);
        this._scheduleDescriptionsArray = responseData.scheduleDescription;
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }

  /**
   * updateSchedule
   */
  public updateSchedule(schedule: Schedule, organizationId: string) {
    return this._http
      .post<Schedule>(
        environment.serverUrl + 'schedules/update',
        {
          'organizationId': organizationId,
          'schedule': schedule
        }
      ).pipe(
        map(responseData => {
          if (this._schedulesArray.length === 0) {
            this._schedulesArray.push(responseData);
            this.onSchedulesArrayChange.next();
            return;
          }
          const index = this._schedulesArray.map(item => {
            return item.id;
          }).indexOf(responseData.id);
          if (index < 0) {
            this._schedulesArray.push({ ...responseData });
          } else {
            this._schedulesArray[index] = responseData;
          }
          this.onSchedulesArrayChange.next();
          return;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }

  /**
   * deleteScheduleById
   */
  public deleteScheduleById(index: number) {
    let paramas = new HttpParams();
    const scheduleId = this.schedules[index].id;
    paramas = paramas.append('id', scheduleId.toString());
    return this._http.delete<void>(environment.serverUrl + 'schedule', {
      params: paramas,
    }).pipe(
      map(() => {
        this._schedulesArray.splice(index, 1);
        this.onSchedulesArrayChange.next();
      }),
      catchError(errorRes => {
        return throwError(errorRes);
      })
    );
  }


  /**
   * updateSchedule
   */
  public updateScheduleDescription(organizationId: string, scheduleDescriptionObject: any) {
    scheduleDescriptionObject['orgId'] = organizationId;
    return this._http
      .post<any>(
        environment.serverUrl + 'schedules/updateComment',
        scheduleDescriptionObject
      ).pipe(
        map(responseData => {
          return responseData;
        }),
        catchError(errorRes => {
          return throwError(errorRes);
        })
      );
  }
}
